import { SUPPLIER_EDIT } from "../actions/supplierActions";

const initialState = {
  allSuppliers: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SUPPLIER_EDIT:
      return { ...state, ...payload };

    default:
      return state;
  }
};
export default reducer;
